import React from 'react'
import { connect } from 'react-redux'
import { toast, ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import {
  AdditionalFields,
  Footer,
  Header,
  Loader,
  PaymentFields,
} from '../components'
import withRouter from '../HOC/widthRouter'
import { baseURL } from '../http'
import { GuestActionCreators } from '../redux/reducers/guest/action-creators'
import { Languages } from '../redux/reducers/language/languageData'

import { ServiceActionCreators } from '../redux/reducers/service/action-creators'
import { fetchWithTimeout } from '../utils/query'

import { getQueryParams } from '../utils/query'
import AdditionalFields1356 from '../components/AdditionalFields1356'
import PaymentFields1356 from '../components/PaymentFields1356'

import '../styles/components/Service1356.scss'
import { documentTitle, isSmsRadarServiceId } from '../utils/consts'

const cardSelectorCategories = new Set([9, 5, 10, 16])
const cardSelectorServices = new Set([1069])

class Service1356 extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      previousLang: undefined,
      fields: [],
      groupId: 0,
      isClientExist: false,
      allFieldsHaveData: false,
      isLoading: false,
      isModalVisible: false,
      amountValue: '',
      webcam: false,
      msgType: '',
      subVal: '',
      autoRedirectToPayment: false,
      subName: '',
      additionalDebtFields: [],
      isAmountCorrect: true,
      fieldsForPicker: [
        { label: 'Visa', key: 'newcard_visa', value: 'newcard_visa' },
        { label: 'MasterCard', key: 'newcard_mc', value: 'newcard_mc' },
      ],
      cardPanId: 'newcard_visa',
      loadingNotTransparent: false,
      commission: '',
      currency: '',
    }
  }

  componentDidMount = async () => {
    document.title = documentTitle

    function detectWebcam(callback) {
      let md = navigator.mediaDevices
      if (!md || !md.enumerateDevices) return callback(false)
      md.enumerateDevices().then(devices => {
        callback(devices.some(device => 'videoinput' === device.kind))
      })
    }
    detectWebcam(hasWebcam => {
      this.setState({ webcam: hasWebcam })
    })

    const { getServiceById } = this.props

    const id = isSmsRadarServiceId

    await getServiceById({
      selected: [+id],
      hash: +id,
    })
  }

  getAlertText = () => {
    const { language: selectedLanguage } = this.props.language
    const language = Languages(selectedLanguage)

    const { msgType } = this.state
    console.log(`msgType:`, msgType)

    const getErrorMessage = msgType => {
      let errorMessage = null

      if (msgType === 0) {
        errorMessage = language.someError
      }

      if (msgType === 1) {
        errorMessage =
          selectedLanguage === 'az'
            ? 'Qeyd etdiyiniz protokolun seriya və ya nömrəsi səhvdir.'
            : selectedLanguage === 'ru'
            ? 'Серийный номер протокола или указанный вами номер неверен.'
            : 'The serial or number of the protocol you registered is incorrect.'
      }

      if (msgType === 2) {
        errorMessage =
          language['The penalty protocol you mentioned has already been paid!']
      }

      return errorMessage
    }

    return getErrorMessage(msgType)
  }

  notifyWebcamError = () => {
    const { language: selectedLanguage } = this.props.language
    const language = Languages(selectedLanguage)
    toast.error(language.notWebcam, {
      position: toast.POSITION.TOP_CENTER,
    })
  }

  componentDidUpdate = async (_, prevS) => {
    if (prevS.allFieldsHaveData !== this.state.allFieldsHaveData) {
      if (this.state.allFieldsHaveData) {
        await this.onButtonPress()
      }
    }
    if (this.state.autoRedirectToPayment !== prevS.autoRedirectToPayment) {
      if (this.state.autoRedirectToPayment) {
        await this.onButtonPress()
      }
    }
  }

  async checkIfUserExist(serviceId, fields, selectedGroupId) {
    this.setState({ isLoading: true })
    try {
      const response = await fetchWithTimeout(
        `${baseURL}/guest/categories/client_info_with_group_id?fields=${encodeURIComponent(
          fields,
        )}&selectedGroupId=${selectedGroupId}&serviceId=${serviceId}`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Payment-Origin': 'frames',
          },
        },
      )
      if (response.status === 200) {
        const json = await response.json()
        if (json?.info?.resultCode === 'ASAN_PAYMENT_IS_ALREADY_PAID') {
          this.setState({ msgType: 2 })
        } else {
          if (json.resultCodes !== 'OK') {
            this.setState({ allFieldsHaveData: false })
          }
          if (json.resultCodes === 'OK') {
            this.setState({ isClientExist: true, checkData: json })
          } else if (
            json.resultCodes === 'NOT_FOUND' ||
            json.resultCodes === 'CUSTOMER_NOT_FOUND' ||
            json.resultCodes === 'INVALID_PARAMETERS' ||
            json.resultCodes === 'UNKNOWN_ERROR'
          ) {
            this.setState({ msgType: 1 })
          } else if (
            json.resultCodes === 'UNDECIDED_PROTOCOL' ||
            json.resultCodes === 'PROTOCOL_CANT_DECIDED'
          ) {
            this.setState({ showVerdictFields: true })
          } else {
            this.setState({ msgType: 0 })
          }
        }
      } else {
        this.setState({ msgType: 0 })
      }
    } catch (e) {
      this.setState({ msgType: 0 })
    } finally {
      this.setState({ isLoading: false })
    }
  }

  async onButtonPress(e) {
    e?.preventDefault()
    const { service } = this.props
    const { fields, groupId, subName, subVal, cardPanId } = this.state
    const fieldsJSON = JSON.stringify({ fields })
    if (this.props.loading.isPaymentLoading) {
      return
    }
    if (this.state.isClientExist) {
      let loading = false
      if (this.state.isAmountCorrect || Number(this.state.paramAmountValue)) {
        let { language = 'az' } = getQueryParams()

        this.setState({ isLoading: true })

        try {
          loading = true
          const url = await this.props.doGuestPay(
            service.id,
            this.state.paramAmountValue
              ? Number(this.state.paramAmountValue)
              : Number(this.state.amountValue),
            fieldsJSON,
            false,
            subName,
            subVal,
            groupId || 0,
            `${window.location.origin}/frames/${language}/check/${isSmsRadarServiceId}`,
            cardPanId,
          )

          if (url) {
            window.location = url
          } else {
            throw new Error()
          }
        } catch (e) {
          this.setState({ isLoading: false })
          loading = false
        } finally {
          if (!loading) {
            this.setState({ isLoading: false })
          } else {
            this.setState({ isLoading: true })
          }
        }
      }
    } else {
      this.checkIfUserExist(service.id, fieldsJSON, groupId || 0)
    }
  }

  renderPicker() {
    const { language: selectedLanguage } = this.props.language
    const language = Languages(selectedLanguage)
    return (
      <div className='service_fields-item'>
        <div className='service_fields-item-title'>{language.selectCard}</div>
        <select
          onChange={e => {
            this.setState({ cardPanId: e.target.value })
          }}
          value={this.state.cardPanId}
        >
          {this.state.fieldsForPicker.map((item, i) => {
            return (
              <option key={item.key} value={item.value}>
                {item.label}
              </option>
            )
          })}
        </select>
      </div>
    )
  }

  render() {
    const { language: selectedLanguage, langKey } = this.props.language
    const language = Languages(selectedLanguage)

    const { service, serviceError } = this.props

    const { loadingNotTransparent } = this.state

    if (serviceError) {
      return <div className='service_error'>Ошибка при загрузке Сервиса</div>
    }

    const loader = (
      <div
        className={`loader-wrapper ${
          loadingNotTransparent ? 'loader-wrapper--not-transparent' : ''
        } `}
      >
        <Loader />
      </div>
    )

    if (Object.keys(service).length === 0) {
      return loader
    }

    const {
      isClientExist,
      checkData,
      isAmountCorrect,
      showVerdictFields,
      fieldsForPicker,
      webcam,
      msgType,
    } = this.state

    const serviceDescription =
      `<div class="service_description-field-title">${language.information}!</div>` +
      service?.localDesc?.[langKey]

    // const isRightColumn =
    //   service?.localDesc?.[langKey] !== '' ||
    //   this.state.additionalDebtFields?.length !== 0

    const isRightColumn = false

    const containerClassName = isRightColumn
      ? 'container'
      : 'container container--not-right-column'

    if (msgType === 2) {
      return (
        <div className='container-wrapper green'>
          <div className='already-paid'>
            <div className='already-paid_body'>
              <div className='already-paid_body_text'>
                {
                  language[
                    'The penalty protocol you mentioned has already been paid!'
                  ]
                }
              </div>
            </div>
          </div>
        </div>
      )
    }

    if (msgType === 2) {
      return (
        <div className='container-wrapper green'>
          <div className='already-paid'>
            <div className='already-paid_body'>
              <div className='already-paid_body_text'>
                {
                  language[
                    'The penalty protocol you mentioned has already been paid!'
                  ]
                }
              </div>
            </div>
          </div>
        </div>
      )
    } else if (msgType !== '' && !this.state.isClientExist) {
      return (
        <div className='container-wrapper green'>
          <div className='already-paid'>
            <div className='already-paid_body'>
              <div className='already-paid_body_text already-paid_body_text--error'>
                {this.getAlertText()}
              </div>
            </div>
          </div>
        </div>
      )
    }

    return (
      <>
        <div className='container-wrapper green'>
          {/* <Header containerClassName={containerClassName} /> */}
          <div className={containerClassName}>
            <div className='service-wrapper'>
              <div className='service'>
                <form
                  className='service_form'
                  onSubmit={e => {
                    this.onButtonPress(e)
                  }}
                >
                  {/* <h1 className='service_title'>{service.localName[langKey]}</h1> */}
                  <div className='service_content'>
                    <PaymentFields1356
                      showVerdictFields={showVerdictFields}
                      service={service}
                      onValueChange={s => this.setState(s)}
                      isClientExist={isClientExist}
                      azercell={service?.id === 976}
                      fieldsForPicker={fieldsForPicker}
                      webcam={webcam}
                      notifyWebcamError={this.notifyWebcamError}
                    />
                    {isClientExist && (
                      <>
                        <AdditionalFields1356
                          onChange={s => this.setState(s)}
                          isAmountCorrect={isAmountCorrect}
                          service={service}
                          checkData={checkData}
                        />
                        {(cardSelectorCategories.has(service?.categoryId) ||
                          cardSelectorServices.has(service?.id)) &&
                          this.renderPicker()}
                      </>
                    )}
                  </div>
                  <div className='service_check-btn-wrapper'>
                    <button
                      className='service_check-btn'
                      disabled={!isAmountCorrect && isClientExist}
                    >
                      {isClientExist ? language.pay : language.check}
                    </button>
                  </div>
                  {this.state.commission && (
                    <span className='commission'>
                      {language.commission +
                        ' ' +
                        this.state.commission +
                        ' ' +
                        (this.state.currency || 'AZN')}
                    </span>
                  )}
                </form>
                {(this.state.isLoading ||
                  this.props.loading.isLoading ||
                  this.props.loading.isPaymentLoading) &&
                  loader}
              </div>
              {/* {(service.localDesc[langKey] ||
              this.state.additionalDebtFields?.length !== 0) && (
              <aside className='right-column'>
                {service.localDesc[langKey] && (
                  <div
                    className='service_fields-item service_description-field'
                    dangerouslySetInnerHTML={{
                      __html: serviceDescription,
                    }}
                  ></div>
                )}
                {this.state.additionalDebtFields?.length !== 0 && (
                  <div className='service_fields-item service_debt-additional-field-items'>
                    {this.state.additionalDebtFields?.map((item, index) => {
                      return (
                        <div
                          className='service_debt-additional-field-item'
                          key={index}
                        >
                          <div className='service_debt-additional-field-item-title'>
                            {item.mutliLangValueString[langKey].replace(
                              /<[^>]+>/g,
                              ' ',
                            )}
                          </div>
                          <div className='service_debt-additional-field-item-body'>
                            {item.value}
                          </div>
                        </div>
                      )
                    })}
                  </div>
                )}
              </aside>
            )} */}
            </div>
          </div>
          {/* <Footer containerClassName={containerClassName} /> */}
        </div>

        <ToastContainer />
      </>
    )
  }
}

const mapStateToProps = state => {
  const {
    service: { service, error: serviceError },
    loading,
    language,
  } = state
  return {
    service,
    loading,
    serviceError,
    language,
  }
}

const mapDispatchToProps = {
  getServiceById: ServiceActionCreators.getServiceById,
  doGuestPay: GuestActionCreators.doGuestPay,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(Service1356))
